import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap } from 'rxjs';

@Injectable()
export class FilesService {
  constructor(private http: HttpClient) {}

  /* uploadFile(url: string, file: File): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    return this.http.post<any>(url, formData);
  } */
  /* downloadFile(url: string, filename: string): Observable<any> {
    return this.http
      .get<any>(`${url}/${filename}`)
      .pipe(catchError((error: any) => of(error)));
  } */

  getData(url: string, filename: string): Observable<string> {
    return this.http
      .get(`${url}/${filename}`, {
        responseType: 'blob',
      })
      .pipe(switchMap((response) => this.readFile(response)));
  }

  getDataByUrl(url: string): Observable<string> {
    return this.http
      .get(url, {
        responseType: 'blob',
      })
      .pipe(switchMap((response) => this.readFile(response)));
  }

  private readFile(blob: Blob): Observable<string> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return new Observable((obs: any) => {
      const reader = new FileReader();

      reader.onerror = (err) => obs.error(err);
      reader.onabort = (err) => obs.error(err);
      reader.onload = () => obs.next(reader.result);
      reader.onloadend = () => obs.complete();

      return reader.readAsDataURL(blob);
    });
  }

  getDocumentFile(url: string): Observable<Blob> {
    return this.http.get<Blob>(url, { responseType: 'blob' as 'json' });
  }
}
